import React from 'react';
import '../styles/CategoryNavigation.css';
import '../styles/animations.css';
import categoriesData from '../data/categories.json';

const CategoryNavigation = ({ 
  categories, 
  activeCategory, 
  setActiveCategory,
  elements,
  activeElement,
  setActiveElement,
  className
}) => {
  // Helper function to get category name from categories.json
  const getCategoryName = (categoryId) => {
    const category = categoriesData.categories.find(cat => cat.id === categoryId);
    if (category && category.name && category.name.en) {
      return category.name.en;
    }
    return categoryId.charAt(0).toUpperCase() + categoryId.slice(1);
  };
  
  // Handle category change
  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    // Set the first element of the new category as active
    if (elements[category] && elements[category].length > 0) {
      setActiveElement(elements[category][0]);
    }
  };

  return (
    <div className={`category-navigation ${className || ''}`}>
      <div className="categories-tabs">
        {categories.map((category, index) => (
          <button
            key={category}
            className={`category-tab ${activeCategory === category ? 'active' : ''}`}
            onClick={() => handleCategoryChange(category)}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            {getCategoryName(category)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryNavigation;
